/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectWithIntegrations } from './ProjectWithIntegrations';
import {
    ProjectWithIntegrationsFromJSON,
    ProjectWithIntegrationsFromJSONTyped,
    ProjectWithIntegrationsToJSON,
    ProjectWithIntegrationsToJSONTyped,
} from './ProjectWithIntegrations';

/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * $projectsWithIntegrations
     * @type {Array<ProjectWithIntegrations>}
     * @memberof Status
     */
    projectsWithIntegrations?: Array<ProjectWithIntegrations>;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    phpVersion?: string;
}

/**
 * Check if a given object implements the Status interface.
 */
export function instanceOfStatus(value: object): value is Status {
    return true;
}

export function StatusFromJSON(json: any): Status {
    return StatusFromJSONTyped(json, false);
}

export function StatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status {
    if (json == null) {
        return json;
    }
    return {
        
        'projectsWithIntegrations': json['projectsWithIntegrations'] == null ? undefined : ((json['projectsWithIntegrations'] as Array<any>).map(ProjectWithIntegrationsFromJSON)),
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'phpVersion': json['phpVersion'] == null ? undefined : json['phpVersion'],
    };
}

export function StatusToJSON(json: any): Status {
    return StatusToJSONTyped(json, false);
}

export function StatusToJSONTyped(value?: Status | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectsWithIntegrations': value['projectsWithIntegrations'] == null ? undefined : ((value['projectsWithIntegrations'] as Array<any>).map(ProjectWithIntegrationsToJSON)),
        'timezone': value['timezone'],
        'phpVersion': value['phpVersion'],
    };
}

